export default __webpack_public_path__ + "static/B09-31e247dfe65e688b2fbaa004edb25b15.png";